// Typelizer digest 875130f7dc51d307cadc856504881aef
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/documents/:document_id/correction */
  update: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/correction', params, options),
    method: 'patch',
  }),
}
